export const requestCaptchaToken = ({ wixCodeApi, platformAPIs })=>async ()=>{
        const isTestRun = ()=>{
            const baseUrl = wixCodeApi.location.baseUrl;
            const isDev = !!wixCodeApi.location.query.viewerPlatformOverrides;
            const isThunderboltTests = !!wixCodeApi.location.query.thunderboltTag;
            const isEditorElementsTests = !!wixCodeApi.location.query['editor-elements-override'];
            const isBoltTests = !!wixCodeApi.location.query.boltTag;
            const isFormBoltTests = baseUrl.startsWith('https://platform-integration');
            const isQaFormTests = baseUrl.startsWith('https://qatestformsuser');
            const isEditorPreview = wixCodeApi.window.viewMode === 'Preview';
            return isDev || isThunderboltTests || isEditorElementsTests || isBoltTests || isFormBoltTests || isEditorPreview || isQaFormTests;
        };
        const forceCaptcha = !!wixCodeApi.location.query.forceChallenge;
        const isBot = !!platformAPIs.bi?.isjp;
        let captchaToken;
        if (!isTestRun() || forceCaptcha) {
            if (isBot) {
                captchaToken = await wixCodeApi.authentication.openCaptchaChallenge();
                if (!captchaToken) {
                    throw new Error('captcha error');
                }
            }
        }
        return captchaToken;
    };

//# sourceMappingURL=captcha-token.js.map